import {
  IRequirementDefinitionCreateRequest,
  IRequirementDefinitionResponse
} from "@wingspanhq/payments/dist/interfaces";
import { servicePayments } from "../servicePayments";

export const createRequirementDefinition = async (
  payload: IRequirementDefinitionCreateRequest
): Promise<IRequirementDefinitionResponse> => {
  const response = await servicePayments.post(
    `/requirement-definition`,
    payload
  );
  return response.data;
};
